import React from "react";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import {
  deleteQuotation,
  getQuotationRequirements,
  getQuotationsOfRequrements,
} from "../../../redux/features/assetManagementSlice";
import { useSelector } from "react-redux";

const DeleteQuotation = ({
  dispatchParams,
  quotationId,
  requirementID,
  isClosed,
  isEditable,
}) => {
  const { loading } = useSelector((store) => store.assetmanagement);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  return (
    <GlobalDeleteDialog
      disabled={isClosed || isEditable}
      title={"Delete"}
      deleteNote={"Are you sure? you want to delete this Quotation..?"}
      api={deleteQuotation(quotationId)}
      //   upDateCall={ getQuotationRequirements(dispatchParams)  }
      upDateCall={getQuotationsOfRequrements(requirementID)}
      //   updatePaginationCall={savePaginationData({ ...paginationData, openAnchor: false })}
      loading={loading}
    />
  );
};

export default DeleteQuotation;
